import type {
  CrearAceptacionAsesorInput,
  EstadoAceptacionAsesor,
  EstadoExpediente,
  RechazarAceptacionAsesorInput,
} from "@copi/shared";

import { apiClient } from "./client";
import { unwrap } from "./unwrap";

export interface AceptacionAsesorWire {
  id: string;
  expedienteId: string;
  estudianteId: string;
  asesorPropuestoId: string;
  tituloPropuesto: string;
  resumen: string;
  lineaInvestigacion: string | null;
  estado: EstadoAceptacionAsesor;
  motivoRechazo: string | null;
  documentoCartaId: string | null;
  fechaSolicitud: string;
  fechaRespuesta: string | null;
  expediente: {
    id: string;
    codigoExpediente: string;
    estadoActual: EstadoExpediente;
  };
  estudiante: {
    id: string;
    nombres: string;
    apellidos: string;
    correo: string;
  };
  asesorPropuesto: {
    id: string;
    nombres: string;
    apellidos: string;
    correo: string;
  };
}

export const aceptacionAsesorApi = {
  /** Estudiante propone título + asesor → expediente transita a ASESORIA_SOLICITADA. */
  crear(input: CrearAceptacionAsesorInput): Promise<AceptacionAsesorWire> {
    return apiClient
      .post("/aceptaciones-asesor", input, { idempotent: true })
      .then(unwrap<AceptacionAsesorWire>);
  },

  /** Asesor acepta → genera CARTA_ACEPTACION_ASESOR (PDF firmable con QR) + transiciona. */
  aceptar(id: string): Promise<AceptacionAsesorWire> {
    return apiClient
      .post(`/aceptaciones-asesor/${id}/aceptar`, {})
      .then(unwrap<AceptacionAsesorWire>);
  },

  /** Asesor rechaza con motivo → expediente vuelve a BORRADOR_SOLICITUD. */
  rechazar(id: string, input: RechazarAceptacionAsesorInput): Promise<AceptacionAsesorWire> {
    return apiClient
      .post(`/aceptaciones-asesor/${id}/rechazar`, input)
      .then(unwrap<AceptacionAsesorWire>);
  },

  /** Mis propuestas. Para estudiantes: las que envié. Para asesores: las que me enviaron. */
  mias(): Promise<AceptacionAsesorWire[]> {
    return apiClient.get("/aceptaciones-asesor/mias").then(unwrap<AceptacionAsesorWire[]>);
  },

  /**
   * Aceptación viva (PENDIENTE o ACEPTADA) de un expediente.
   * Usado por el Decanato para precargar el asesor confirmado en el handshake
   * al momento de designar (ADR 008). Devuelve null si no hay handshake.
   */
  obtenerVivaDelExpediente(expedienteId: string): Promise<AceptacionAsesorWire | null> {
    return apiClient
      .get(`/aceptaciones-asesor/expediente/${expedienteId}/viva`)
      .then(unwrap<AceptacionAsesorWire | null>);
  },
};
